import React from "react";

const InstructionNotification = ({ message, colSpan }) => {
    if (colSpan) {
        return (
            <>
                <tr>
                    <td colSpan={colSpan}>
                        <div className="px-6 py-3 whitespace-wrap text-xs">
                            {message}
                        </div>
                    </td>
                </tr>
            </>
        );
    } else {
        return (
            <>
                <div className="px-6 py-3 whitespace-wrap text-xs w-full">
                    {message}
                </div>
            </>
        );
    }
};

export default InstructionNotification;
